export const SEXO = {
  MASCULINO: 0,
  FEMININO: 1,
  OUTROS: 2,
};

export const ZONA_LOCALIZACAO = {
  URBANA: 0,
  RURAL: 1,
};
